export default __webpack_public_path__ + "static/media/4-friend-icon.bdb94ef7.svg";